import styled from 'styled-components'

export const DashboardPage = styled.div.attrs({
})`            
    width: 100%;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: relative;
    overflow: hidden;
`;

export const DashboardBody = styled.div.attrs({
    'data-testid': 'authenticated-scroll-region',
})`       
    height: 100%;
    min-height: 0;
    background: ${props => props.theme.palette.colors.background};
    width: 100%;
    display: flex;
    align-items: flex-start;     
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    transition: width 0.3s;
    @media (max-width: 991px) {
        width: 100%;
    }
`;

export const DashboardBodyContent = styled.div.attrs({
})`            
    width: 100%;
    min-height: 100vh;
`;

export const Content = styled.div.attrs({
})`           
    position: fixed;
    inset: 0;
    overflow: hidden;
`;
